<template>
  <v-container fluid style="padding-top: 0;">
    <v-col cols="12" class="content-box" v-if="searchProducts">
      <v-row>
        <v-col cols="12" md="5">
          <img
            v-if="imageSelected == null"
            :aspect-ratio="4 / 3"
            width="100%"
            contain
            src="../../../assets/no_image.jpg"
            alt="noImage"
          />
          <v-img
            v-else
            :lazy-src="imageSelected"
            :src="imageSelected"
            width="100%"
            class="grey lighten-2"
            style="margin-bottom: 18px"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-row class="overflow-x-auto">
            <v-col
              cols="3"
              v-for="(item, index) in itemData.pictures"
              :key="index"
            >
              <v-hover v-slot="{ hover }">
                <v-img
                  :lazy-src="item"
                  :src="item"
                  width="100%"
                  height="100px"
                  class="grey lighten-2 rounded-img"
                  @click="() => handlerSelectedImage(item)"
                  :style="
                    hover
                      ? 'cursor: pointer; opacity: 0.8; background-color: black; z-index:10;'
                      : ''
                  "
                >
                  <v-row
                    v-if="hover"
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-btn fab color="white" small>
                      <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </v-row>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="7">
          <div class="title-text">{{ itemData.title }}</div>
          <v-tabs color="#343EC4" v-model="tab">
            <v-tab value="0">Precio</v-tab>
            <v-tab value="1">Caracteristicas</v-tab>
          </v-tabs>
          <div v-if="tab == 0" class="pt-10">
            <v-col cols="12" md="11" lg="9">
              <v-slider
                step="1"
                min="0"
                :max="maxSlider"
                thumb-label="always"
                v-model="stepQuantity"
                ticks="always"
                tick-size="3"
                color="#6400D2"
                track-color="rgba(100, 0, 210, 0.35)"
              >
                <template v-slot:thumb-label="{ value }">
                  {{ productQuantity[value].quantity }}
                </template>
              </v-slider>
              <div class="sub-title">Precio</div>
              <v-row>
                <v-col cols="7" class="detail-text"
                  >Precio Comercio Neto Unitario</v-col
                >
                <v-col cols="5" class="amount-text"
                  >${{ getPvcWithDiscount() | number_format }} + IVA ({{
                    itemData.iva
                  }})%</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" class="detail-text">Mark UP</v-col>
                <v-col cols="5" class="amount-text"
                  >{{ getMarkUp() | number_format }} %</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" class="detail-text">Precio Público</v-col>
                <v-col cols="5" class="amount-text"
                  >${{ itemData.pvp_with_discount | number_format }}</v-col
                >
              </v-row>
              <div class="d-flex flex-row">
                <div class="discount-text">Comprando</div>
                <div class="discount-text stock-text">
                  {{ productQuantity[stepQuantity].quantity }}
                </div>
                <div class="discount-text">
                  Unidades obtienes un descuento de
                </div>
                <div class="discount-text stock-text">
                  {{ productQuantity[stepQuantity].discount_percentage }} %
                </div>
              </div>
              <div class="sub-title">Disponibilidad</div>
              <v-row>
                <v-col cols="7" class="detail-text"
                  >Disponibilidad en el stock:</v-col
                >
                <v-col
                  cols="5"
                  class="stock-text"
                  :style="{ color: getColor(itemData) }"
                  >{{ itemData.stock_text.message }}</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="7" class="detail-text">Próximo ingreso:</v-col>
                <v-col cols="5" class="amount-text">{{
                  itemData.available_date
                }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="detail-text">Compra mínima</v-col>
                <v-col cols="5" class="amount-text"
                  >{{ itemData.purchase_options[0].quantity }} unidades</v-col
                >
              </v-row>
            </v-col>
          </div>
          <div v-else class="pt-6">
            <v-col cols="12" md="11" lg="9">
              <div v-html="itemData.description"></div>
            </v-col>
          </div>
          <v-col cols="12">
            <div class="d-flex flex-row justify-end">
              <v-btn
                class="outline-btn mr-3"
                @click="$router.go(-1)"
                :loading="loading"
                :disabled="loading"
                >VOLVER</v-btn
              >
              <!--<v-btn class="blue-btn" @click="handlerAddProduct" :loading="loading" :disabled="loading">AÑADIR</v-btn>-->
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
    <v-row v-else>
      <v-col class="mx-auto">
        <looping-rhombuses-spinner
          class="mx-auto"
          :animation-duration="2500"
          :rhombus-size="80"
          color="#402DCE"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  components: {
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      imageSelected: null,
      tab: "0",
      searchProducts: false,
      stepQuantity: 0,
      maxSlider: 0,
      productQuantity: [],
      loading: false,
    };
  },
  mounted() {
    const id = this.$route.query.id;
    this.getProductDetails(id);
  },

  watch: {
    itemData() {
      this.imageSelected = this.itemData?.pictures[0];
    },
  },

  filters: {
    number_format(
      value,
      decimals = 2,
      separatorThousands = ".",
      separatorDecimals = ","
    ) {
      let number = parseFloat(value);
      if (!isFinite(number) || (!number && number !== 0)) return "";
      let [integer, decimal] = Math.abs(number)
        .toFixed(decimals)
        .split(".");
      let length = integer.length;
      while (length > 3) {
        length -= 3;
        integer =
          integer.slice(0, length) + separatorThousands + integer.slice(length);
      }
      let sign = number < 0 ? "-" : "";
      return `${sign}${integer}${separatorDecimals}${decimal}`;
    },
  },
  created() {
    this.getShoppingCart();
  },

  computed: {
    itemData() {
      console.log(this.$store.getters["product/GET_SELECTED_PRODUCT"]);
      return this.$store.getters["product/GET_SELECTED_PRODUCT"];
    },
    cartItems() {
      return this.$store.getters["shoppingCart/GET_CART_ITEMS"];
    },
  },

  methods: {
    getPvcWithDiscount() {
      const { net_pvc } = this.itemData.purchase_options[this.stepQuantity];
      return net_pvc;
    },

    getMarkUp() {
      const { mark_up } = this.itemData.purchase_options[this.stepQuantity];
      return mark_up;
    },

    getColor(item) {
      switch (true) {
        case item.stock_text.message.toLowerCase() == "no disponible":
          return "#D32F2F !important";
        case item.stock_text.message.toLowerCase() == "disponibilidad baja":
          return "#6400D2 !important";
        case item.stock_text.message.toLowerCase() == "disponibilidad media":
          return "#ED6C02 !important";
        default:
          return "#343EC4 !important";
      }
    },

    async getProductDetails(id) {
      try {
        this.searchProducts = false;
        const request = {
          publication_id: id,
        };
        const response = await this.$store.dispatch(
          "product/GET_PRODUCT_DETAILS",
          request
        );
        this.productQuantity = response.purchase_options;
        this.maxSlider = response.purchase_options.length - 1;
        this.searchProducts = true;
      } catch (error) {
        this.searchProducts = false;
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.searchProducts = true;
      }
    },

    handlerSelectedImage(img) {
      this.imageSelected = img;
    },

    async getShoppingCart() {
      try {
        await this.$store.dispatch("shoppingCart/GET_SHOPPING_CART");
      } catch (error) {
        Swal.fire({
          title: "Un error ha ocurrido",
          text: "Tenemos problemas para obtener su carrito intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      }
    },

    async handlerAddProduct() {
      this.loading = true;
      try {
        const request = {
          shopping_cart_id: this.cartItems.id,
          b2b_purchase_option_id: this.itemData.purchase_options[
            this.stepQuantity
          ].id,
        };
        const response = await this.$store.dispatch(
          "shoppingCart/ADD_PRODUCT_CART",
          request
        );
        if (response) {
          this.getShoppingCart();
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
          });
          Toast.fire({
            icon: "success",
            title: "Se ha añadido este item a tu orden de compra",
          });
        }
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.content-box {
  background-color: white;
  border-radius: 10px;
}
.rounded-img {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14))
    drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  border-radius: 10px;
}
.v-slider__track-container {
  height: 4px !important;
}
.v-slider__thumb {
  cursor: pointer !important;
}
.v-slider__thumb-label {
  height: 26px !important;
  width: 26px !important;
}
.title-text {
  font-size: 34px;
  font-weight: 500;
  color: black;
}
.sub-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
  margin: 10px 0 15px 0;
}
.detail-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.amount-text {
  font-size: 16px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.stock-text {
  font-size: 12px;
  font-weight: 400;
  color: #f49538 !important;
  margin-bottom: 6px;
  text-transform: uppercase;
}
.discount-text {
  font-size: 14px;
  font-weight: 700;
  color: black;
  margin-bottom: 6px;
  text-transform: uppercase;
  margin-right: 4px;
}
.blue-btn {
  height: 42px !important;
  background-color: #343ec4 !important;
  color: white !important;
  font-size: 12px !important;
}
.outline-btn {
  height: 42px !important;
  background-color: white !important;
  color: #343ec4 !important;
  border: solid 1px #343ec4;
  font-size: 12px !important;
}
</style>
